// src/contexts/LanguageContext.js
// Version: 1.0.1 - To provide lang and setLang
import { createContext } from 'react';

export const LanguageContext = createContext({
  lang: 'ja', // Default language
  setLang: () => {} // Placeholder function
});
